import { render } from "./Relationship.vue?vue&type=template&id=daf7e57a&scoped=true"
import script from "./Relationship.vue?vue&type=script&lang=js"
export * from "./Relationship.vue?vue&type=script&lang=js"

import "./Relationship.vue?vue&type=style&index=0&id=daf7e57a&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daf7e57a"]])

export default __exports__